import axios from "axios";
import { getToken } from "./auth";

// controla sessão e requisições
let isSessionExpired = false;
let controllers = new Set();

export function abortAllRequests() {
  controllers.forEach((controller) => controller.abort());
  controllers.clear();
}

export function setSessionExpired(state = true) {
  isSessionExpired = state;
}

const api = axios.create({
  baseURL:
    process.env.VUE_APP_BACKEND_API_URL ??
    "https://prod-new-contdigital-app-e68e48353516.herokuapp.com/",
});

// instância sem interceptor de auth, para chamadas a domínios externos (ex.: ViaCEP)
export const publicApi = axios.create();

api.interceptors.request.use(async (api_config) => {
  if (isSessionExpired) {
    throw new axios.Cancel("Sessão expirada, requisição bloqueada.");
  }

  const token = getToken();
  if (token) api_config.headers.Authorization = `Bearer ${token}`;

  const controller = new AbortController();
  api_config.signal = controller.signal;
  controllers.add(controller);

  return api_config;
});

api.interceptors.response.use(
  (response) => {
    try {
      if (response.config.signal) controllers.delete(response.config.signal);
    } catch (e) {
      //test
    }
    return response;
  },
  async (error) => {
    const status = error.response?.status;
    const shouldHandleSessionExpired =
      !error.config?.skipSessionExpiredHandler;
    if (status === 401 && shouldHandleSessionExpired && !isSessionExpired) {
      isSessionExpired = true;
      abortAllRequests();
      try {
        window.dispatchEvent(
          new CustomEvent("session-expired", {
            detail: { reason: "401" },
          })
        );
      } catch (e) {
        //
      }
      setTimeout(() => {
        isSessionExpired = false;
      }, 2000);
      return new Promise(() => {});
    }
    if (error.code === "ERR_CANCELED" || error.name === "CanceledError") {
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export default api;
